import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';
import DashboardLeftMenu from '../../Dashboard/DashboardLeftMenu';
import EmptyImg from "../../Dashboard/assets/img/create-project.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle, faHourglass, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { checkUserUrl, handleUserLog } from '../../Utils/Utils';
import { HOST_URL } from '../api/Api';
import Axios from '../../../axios/Axios';
class TransactionHistory extends Component {

    constructor() {

        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const url = lStorage.url;
        const resellerId = lStorage?.user?.reseller_id;

        const parent_type = lStorage?.user?.parent_type;

        super();

        this.state = {
            user_id: userId,
            token: userToken,
            url: url,
            reseller_id: resellerId,
            paymentTransactionList: null,
            allTransactions: null,
            fromDate: "",
            toDate: "",
            successMessage: false,
            errorMessage: '',
            bgColor: "alert alert-success alert-dismissible",
            parent_type: parent_type
        }
    }

componentDidMount() {
  Axios
    .post(`${HOST_URL}/transaction_history.php`, {
      user_id: this.state.user_id,
      method: "retrieve",
      token: this.state.token,
    })
    .then((response) => {
      const result = response.data;
      if (result.success === true) {
        // Keep the untouched full list separately so the date filter can be
        // applied/reset without re-fetching.
        this.setState({ paymentTransactionList: result, allTransactions: result.data });
      } else {
        this.setState({
          successMessage: true,
          successBg: "alert alert-danger alert-dismissible",
          errorMessage: result.message,
        });
      }
    })
    .catch((error) => {
      console.error("Error fetching transaction history:", error);
      this.setState({
        successMessage: true,
        successBg: "alert alert-danger alert-dismissible",
        errorMessage: "Something went wrong while fetching transactions.",
      });
    });
}

    // Filters the already-fetched list on the transaction's `created` date
    // (format "YYYY-MM-DD HH:MM:SS") — string comparison on the date part is
    // safe for this format. Either bound can be used on its own.
    dateFilter = () => {
        const { allTransactions, fromDate, toDate } = this.state;
        if (!allTransactions) return;

        if (fromDate && toDate && fromDate > toDate) {
            this.setState({
                successMessage: true,
                bgColor: "alert alert-danger alert-dismissible",
                errorMessage: "From Date cannot be after To Date.",
            });
            return;
        }

        const filtered = allTransactions.filter((item) => {
            const day = (item.created || '').split(' ')[0];
            if (!day) return false;
            if (fromDate && day < fromDate) return false;
            if (toDate && day > toDate) return false;
            return true;
        });

        this.setState((prev) => ({
            successMessage: false,
            errorMessage: '',
            paymentTransactionList: { ...prev.paymentTransactionList, data: filtered },
        }));
    };

    resetDateFilter = () => {
        this.setState((prev) => ({
            fromDate: "",
            toDate: "",
            successMessage: false,
            errorMessage: '',
            paymentTransactionList: prev.allTransactions
                ? { ...prev.paymentTransactionList, data: prev.allTransactions }
                : prev.paymentTransactionList,
        }));
    };



    render() {
        return (
            <div className="wrapper">
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3><strong> Last Transaction </strong> Details </h3>
                                </div>
                            </div>
                            <div className="row">



                                <div className="card">
                                    <div className="">
                                        <h5 className="card-title mt-4">
                                            <div className="col-auto ml-auto text-right mt-n1">
                                                <nav className="text-center" aria-label="breadcrumb">
                                                    <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                        {(checkUserUrl(this.state.url) || window.location.hostname === "console.aireach.in") &&
                                                            <Link to= {(this.state.parent_type !== "reseller" || this.state.reseller_id === 14824 ) && "transaction-payment"} onClick={() => handleUserLog("", "recharge_tab", "transaction_history", "User Click on Recharge tab", "transaction_history", "", "")}> {(this.state.parent_type !== "reseller" || this.state.reseller_id === 14824) && (<li className="breadcrumb-item  ">Recharge </li>)} </Link>
                                                        }
                                                        <Link to="transaction-history" onClick={() => handleUserLog("", "transaction_history_tab", "transaction_history", "User Click on Transaction History tab", "transaction_history", "", "")}><li className="breadcrumb-item active">Transaction History </li> </Link>

                                                    </ol>
                                                </nav>
                                            </div>
                                        </h5>
                                    </div>

                                    <div className="card-body">
                                        {this.state.successMessage &&
                                            <div className={this.state.bgColor} role="alert">
                                                <div className="">{this.state.errorMessage}</div>
                                            </div>
                                        }

                                        {/* From / To date filter */}
                                        <div className="row mb-3">
                                            <div className="col-lg-3 col-md-4 col-12 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-text">
                                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                                    </div>
                                                    <input
                                                        type="date"
                                                        id="fromDate"
                                                        className="form-control"
                                                        value={this.state.fromDate}
                                                        max={this.state.toDate || undefined}
                                                        onChange={(e) => this.setState({ fromDate: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-4 col-12 mb-2">
                                                <div className="input-group">
                                                    <div className="input-group-text">
                                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                                    </div>
                                                    <input
                                                        type="date"
                                                        id="toDate"
                                                        className="form-control"
                                                        value={this.state.toDate}
                                                        min={this.state.fromDate || undefined}
                                                        onChange={(e) => this.setState({ toDate: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-6 mb-2">
                                                <button
                                                    type="button"
                                                    onClick={this.dateFilter}
                                                    className="btn btn-info btn-block"
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-6 mb-2">
                                                <button
                                                    type="button"
                                                    onClick={this.resetDateFilter}
                                                    className="btn btn-secondary btn-block"
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-lg-12 col-xxl-12">
                                                <div className="col-12">


                                                    {this.state.paymentTransactionList ?


                                                        <div className="table-responsive" style={{ overflowX: "auto" }}>
                                                            <table className="table table-striped table-xs table-sm my-0">
                                                                <thead>
                                                                    <tr>

                                                                        <th className="d-xl-table-cell">Amount</th>
                                                                        <th className="d-xl-table-cell">Status</th>
                                                                        <th>Transaction ID</th>
                                                                        <th>Description</th>
                                                                        <th>Balance After</th>
                                                                        <th>Remark</th>
                                                                        <th className="d-md-table-cell">Date / Time</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {this.state.paymentTransactionList.data.length === 0 &&
                                                                        <tr>
                                                                            <td colSpan="7" className="text-center">
                                                                                No transactions found for the selected date range.
                                                                            </td>
                                                                        </tr>
                                                                    }
                                                                    {
                                                                        this.state.paymentTransactionList.data.map((item, i) =>
                                                                            <tr>
                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.amount}</td>

                                                                                <td>
                                                                                    {
                                                                                        item.status === 1 ?
                                                                                            <span className="badge bg-success"> <FontAwesomeIcon icon={faCheckCircle} color='#fff' /> Success </span>
                                                                                            :

                                                                                            item.status === 0 ?
                                                                                                <>
                                                                                                    <span className="badge bg-info"> <FontAwesomeIcon icon={faHourglass} color='#fff' />  Pending  </span>
                                                                                                </>
                                                                                                :
                                                                                                <span className="badge bg-danger"> <FontAwesomeIcon icon={faTimesCircle} color='#fff' />  Failed    </span>
                                                                                    }


                                                                                </td>


                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.transaction_id}</td>
                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.description}</td>
                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.pending_amount}</td>
                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.remark}</td>
                                                                                <td style={{color: item.amount < 0 ? "red" : "green"}}>{item.created}</td>

                                                                            </tr>

                                                                        )
                                                                    }


                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        :
                                                        <div className="text-center">
                                                            <div className="card-body">
                                                                <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                                <p>NO transaction Details Found </p>

                                                            </div>
                                                        </div>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <DashboardFooter />
                </div>
            </div>
        );
    }
}

export default TransactionHistory;